"use client";

import { useEffect } from "react";

export function LandingTracker() {
  useEffect(() => {
    const trackVisit = async () => {
      try {
        // Check if we've already tracked this visit in this session
        const tracked = sessionStorage.getItem("landing_tracked");
        if (tracked) {
          return;
        }

        // Extract UTM params and referrer
        const urlParams = new URLSearchParams(window.location.search);
        const data = {
          referrer: document.referrer || undefined,
          utm_source: urlParams.get("utm_source") || undefined,
          utm_medium: urlParams.get("utm_medium") || undefined,
          utm_campaign: urlParams.get("utm_campaign") || undefined,
          utm_content: urlParams.get("utm_content") || undefined,
          utm_term: urlParams.get("utm_term") || undefined,
        };

        // Only track if we have meaningful data
        if (
          !data.referrer &&
          !data.utm_source &&
          !data.utm_medium &&
          !data.utm_campaign
        ) {
          // Still mark as tracked to avoid repeat attempts
          sessionStorage.setItem("landing_tracked", "true");
          return;
        }

        // Track the visit
        await fetch("/api/analytics/landing-visit", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(data),
        });

        // Mark as tracked for this session
        sessionStorage.setItem("landing_tracked", "true");
      } catch (error) {
        console.error("[LandingTracker] Failed to track visit:", error);
      }
    };

    trackVisit();
  }, []);

  return null;
}
